<template>
  <v-card
    id="dialog-contact-select"
    class="dialog-contact-select"
  >
    <v-card-title class="dialog-title">
      選擇常用收件人
      <i
        class="close icon-close"
        @click="closeDialog"
      />
    </v-card-title>
    <v-card-text class="dialog-content">
      <div
        v-if="loading"
        class="loading"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
      <div
        v-else-if="!contactList.length && !searchKeyword"
        class="notice"
      >
        <img
          src="@/assets/image/empty-common-contact.png"
          alt="無搜尋結果"
        >
        <p class="text-large">
          噢不！<br>
          您尚未建立常用收件人<br>
          請返回訂購流程，<br>
          將此次收件人資訊加入常用寄件人
        </p>
      </div>
      <template v-else>
        <div class="search-area">
          <v-text-field
            v-model="searchKeyword"
            filled
            rounded
            dense
            hide-details="true"
            type="text"
            class="search-input"
            placeholder="請輸入姓名或電話號碼"
          >
            <template #prepend-inner>
              <img
                src="@/assets/image/search.svg"
                alt="搜尋"
              >
            </template>
          </v-text-field>
        </div>
        <v-radio-group
          v-if="contactList.length"
          v-model="selectedIndex"
          class="radio-group"
          :mandatory="false"
        >
          <v-radio
            v-for="(contact, index) in contactList"
            :key="index"
            class="radio"
            :value="index"
          >
            <div
              slot="label"
              class="item"
            >
              <div class="item-content">
                <p>{{ contact.Name }}</p>
                <p>{{ contact.Phone }}</p>
                <p>{{ contact.PostNumber }} {{ contact.City }}{{ contact.Area }}{{ contact.Address }}</p>
              </div>
              <div
                class="delete"
                @click.stop.prevent="contactDialogDelete(contact.id)"
              >
                <i class="close icon-close" />
              </div>
            </div>
          </v-radio>
        </v-radio-group>
        <div
          v-else
          class="notice"
        >
          <img
            src="@/assets/image/empty-common-contact.png"
            alt="無搜尋結果"
          >
          <p class="text-small">
            目前沒有符合條件的常用收件人，換個條件再搜尋看看吧！
          </p>
        </div>
      </template>
    </v-card-text>
    <v-card-actions class="dialog-actions">
      <v-btn
        class="btn"
        depressed
        outlined
        color="primary"
        @click="closeDialog"
      >
        取消
      </v-btn>
      <v-btn
        color="primary"
        class="btn"
        depressed
        :disabled="selectedIndex === null"
        @click="submitDialog"
      >
        確定
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-model="deleteOpen"
      width="530"
    >
      <v-card>
        <v-card-title>
          確定刪除常用收件人？
        </v-card-title>
        <v-card-text />
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="deleteLoading"
            @click="cancelDeleteDialog"
          >
            取消
          </v-btn>
          <v-btn
            color="error"
            :loading="deleteLoading"
            @click="deleteContact"
          >
            刪除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'PackageContact',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    contactList: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: true
    },
    deleteOpen: {
      type: Boolean,
      default: false
    },
    deleteLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedIndex: null,
      deletedIndex: null,
      searchKeyword: '',
      origincContactList: []
    }
  },
  computed: {
  },
  watch: {
    open: {
      handler (value) {
        if (value) {
          setTimeout(() => {
            this.origincContactList = _.cloneDeep(this.contactList)
          }, 500)
        }
      },
      immediate: true
    },
    searchKeyword (value) {
      this.searchContact()
    },
    // 讓已選取卻不在搜尋範圍內的選項調回預設值
    contactList (value) {
      if (value?.length) {
        const selectedItem = this.origincContactList[this.selectedIndex]
        if (selectedItem) {
          const result = selectedItem.Name.includes(this.searchKeyword) || selectedItem.Phone.includes(this.searchKeyword)
          if (!result) {
            this.selectedIndex = null
          }
        }
      }
    }
  },
  async mounted () {
  },
  methods: {
    contactDialogDelete (id) {
      this.deletedIndex = id
      this.$emit('openDelete')
    },
    cancelDeleteDialog () {
      this.$emit('closeDelete')
    },
    closeDialog () {
      this.$emit('close')
      this.selectedIndex = null
      this.searchKeyword = ''
    },
    submitDialog () {
      this.$emit('submit', this.selectedIndex)
      this.selectedIndex = null
      this.searchKeyword = ''
    },
    deleteContact () {
      this.$emit('delete', this.deletedIndex)
      this.selectedIndex = null
    },
    searchContact () {
      this.$emit('search', this.searchKeyword)
    }
  }
}
</script>

<style lang="scss" scoped>
#dialog-contact-select {
  .dialog-content {
    position: relative;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 0;
    border-top: 2px solid $mainColor;
    width: calc(100% - 30px * 2);
    width: calc(100% - 20px * 2 - var(--safe-area-inset-left) - var(--safe-area-inset-right));
    margin-left: auto;
    margin-right: auto;
    .radio-group {
      margin-top: 0;
    }
  }
  .radio {
    padding: 10px;
    border: 1px solid #D2D2D2;
  }
  .item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      display: table-row;
    }
    span {
      display: table-cell;
      padding-bottom: 5px;
    }
    span.label {
      font-weight: bold;
      padding-right: 20px;
    }
  }
  .dialog-title {
    position: relative;
    text-align: center;
    justify-content: center;
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
    padding-top: calc(15px + var(--safe-area-inset-top));
    .icon-close {
      position: absolute;
      right: 20px;
      right: calc(20px + var(--safe-area-inset-right));
      top: 50%;
      transform: translateY(-50%);
      $size: 20px;
      position: absolute;
      line-height: $size;
      font-size: $size * .8;
      color: #888;
      cursor: pointer;
    }
  }
  .dialog-actions {
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 30px;
    padding-bottom: max(30px, calc(10px + var(--safe-area-inset-bottom)));
    .btn {
      padding: 10px 75px;
      height: auto;
      ::v-deep {
        span {
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
    }
  }
  .delete {
    padding-right: 10px;
  }
  .notice {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    i.icon {
      font-size: 50px;
      margin-right: 20px;
    }
    p.text-large {
      text-align: left;
      font-size: pxTorem(17px);
      line-height: pxTorem(23px);
    }
    p.text-small {
      text-align: left;
      font-size: pxTorem(15px);
    }
    img {
      width: 220px;
    }
  }
  .search-area {
    padding: 0 8px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    .search-input {
      img {
        width: 20px;
        margin-right: 8px;
      }
     ::v-deep {
        .v-input__slot {
          background-color: #EAEAEA;
        }
        .v-text-field__slot {
          input {
            &::placeholder {
              font-size: pxTorem(15px);
              color: $midGrayColor;
            }
          }
        }
      }
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  #dialog-contact-select {
    .notice {
      flex-direction: column-reverse;
      i.icon {
        margin-right: 0;
        margin-bottom: 30px;
        margin-top: 20px;
      }
      img {
        margin-top: 16px;
      }
    }
    .dialog-actions {
      display: flex;
      flex-direction: column-reverse;
      .btn {
        width: 300px;
        &:last-child {
          margin: 0 0 12px 0;
        }
      }
    }
  }
}
</style>
